var _style, _text, _text2, _polyline, _ellipse, _circle, _text3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpotlightLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 164.5",
    style: {
      enableBackground: "new 0 0 512 164.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{font-family:'Comfortaa-Bold';}\n\t.st2{font-size:80.3776px;}\n\t.st3{fill:#F2AE1D;}\n\t.st4{fill:#FFD103;}\n\t.st5{fill:#F5B919;}\n\t.st6{fill:#F9C152;}\n\t.st7{font-size:20px;}\n")), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -2.4106 114.0052)",
    className: "st0 st1 st2"
  }, "SPOT")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 230.0894 114.0052)",
    className: "st3 st1 st2"
  }, "L  GHT")), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "328.9,112.8 280.7,26.5 291.6,112.8 "
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st5",
    cx: 310.2,
    cy: 112.8,
    rx: 18.7,
    ry: 3.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 278.3,
    cy: 15.3,
    r: 5.2
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 357.538 152.1582)",
    className: "st0 st1 st7"
  }, "by iimjobs.com")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotlightLogo);
export default __webpack_public_path__ + "static/media/spotlightLogo.f13846f0b706834f5f05b3f26a5330e7.svg";
export { ForwardRef as ReactComponent };